import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { LoadingComponent } from '@components/shared/loading/loading.component';
import { LoadingService } from '@services/loading.service';
import { Subject } from 'rxjs';

export const appVersion: string = '2.1.0';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoadingComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  /** アプリ全体に対するローディング表示 */
  appLoading$: Subject<boolean>;

  constructor(
    private router: Router,
    private loadingService: LoadingService,
  ) {
    this.appLoading$ = loadingService.loading;
  }

  ngOnInit() {
    // 画面遷移前にローディングを表示する。
    // 画面遷移完了後、または、キャンセル後にローディングを非表示にする。
    // 画面遷移が失敗した際は、他のローディングに関わらず、非表示にする。
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loadingService.show();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.loadingService.hide();
      } else if (event instanceof NavigationError) {
        this.loadingService.clear();
      }
    });
  }
}
